<template>
  <el-upload
  
    :file-list="list"
    :limit="limit"
    :accept="accept"
    :multiple="multiple"
    action=""
    :on-remove="handleRemove"
    :before-remove="beforeRemove"
    :before-upload="beforerUpload"
    :on-preview="handlePreview"
    :on-success="handleSuccess"
    :http-request="uploadData"
  >
    <el-button  size="mini" type="primary"  icon="el-icon-upload" 
    :disabled="list.length==1?true:false"
    >
    
    <!-- PDF{{ btntext }} -->
    {{list.length==1?'已上传':'PDF文件上传'}}
    </el-button>
    <div slot="tip" class="el-upload__tip btn-tip" :class="list.length==1? 'hide_box' : ''">{{ tip }}</div>
  </el-upload>
</template>

<script>
import { uploadFile,uploadFilePdf } from '@/api/api_common'
import {
  mp4ToJpg,
} from "@api/bx/api_contentManagement";
export default {
  props: {
    // 上传文件的设置字段
    params: {
      type: Object,
      default: null
    },
    // 上传的文件列表
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: 100
    },
    // 接受上传的文件类型
    accept: {
      type: String,
      default: '.pdf,.PDF'
      // default: '.pem,.xls,.xlsx,.txt,.doc,.pdf,.PDF,image/*'
    },
    // 是否支持多选文件
    multiple: {
      type: Boolean,
      default: false
    },
    // 接受收的提示性文字
    tip: {
      type: String,
      default: ''
    },
    // 上传按钮文字
    btntext: {
      type: String,
      default: '文件上传'
    }
  },
  computed: {
    list: {
      get() {
        return this.fileList
      },
      set(val) {
        this.$emit('update:fileList', val)
      }
    }
  },
  methods: {
    // 上传文件之前的钩子
    beforerUpload(file) {
       if(this.list.length==1){
        console.log(this.list)
        this.$message.error('如需更换，请先移除!')
        return
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!')
      }
      const acceptType = this.accept.split(',')
      let filetype = false
      for (const item of acceptType) {
        if (file.name.endsWith(item)) {
          filetype = true
        }
      }
      // const filetype = file.name.endsWith('.map3') || file.name.endsWith('.wmv')
      if (!filetype) {
        this.$message.error('应上传PDF文件!')
      }
      return isLt100M && filetype
    },
    // 文件上传时的勾子
    uploadData(data) {
      // console.log('0000')
     
      const formData = new FormData()
      formData.append('file', data.file)
      // console.log(formData)
      uploadFile(formData).then(res => {
        // console.log(res)
        const response = { name: res.fileOriginalName, url: res.rootPath, id: res.id, uid: data.file.uid }
        this.list.push(response)
        this.$emit('fileList', this.list)
      })

    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      // console.log(file)

      this.list.splice(0, this.list.length)
      this.list = this.list.concat(fileList)
      this.list = fileList
      // console.log(this.list)
      // this.list=[]
      this.$emit('moveList', this.list)
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log(file)
      if (file.url) {
        window.open(file.url)
        // console.log(file.url)
      }
    },
    beforeRemove() {},
    handleSuccess() {}
  }
}
</script>

<style lang="scss" scoped>
.btn-tip {
	display: inline-block;
	margin-left: 10px;
}
.el-upload__tip{
  margin-top: 0;
}
.hide_box {
  display: none !important;
}
</style>
